import { Injectable } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { CrudHelper } from '../../firebase/helpers/crudHelper';
import { CommonService } from '../../shared/component-store/common-service';
import { AuthService } from 'src/app/firebase/auth.service';

@Injectable()
export class PoolsService extends CommonService {
  userId: string;
  isOpenSuccessModal = new BehaviorSubject(false);
  constructor(
    private fb: FormBuilder,
    private firebaseHelperService: CrudHelper,
    private authService: AuthService
  ) {
    super(firebaseHelperService);
  }

  addImage(images) {
    let i = images.length;
    i = this.fb.group({
      image: [null],
    });
    images.push(i);
  }

  deleteImage(images: FormArray, i: number) {
    images.removeAt(i);
  }

  getProfile(email: string) {
    return this.firebaseHelperService.searchByField('users', 'email', email);
  }

  getItems({ collectionName, filter }) {
    // Special handling for admin approval panel
    if (window.location.pathname.includes('/approvement')) {
      console.log('[Approval Panel] Starting query build for:', collectionName);
      console.log('[Approval Panel] Current filter:', filter);

      const queryFn = ref => {
        let query = ref;
        try {
          // For admin panel, show pending items
          console.log('[Approval Panel] Setting status filter to pending');
          query = query.where('status', '==', 'pending');

          // Add search filters if they exist
          if (filter?.searchString && filter.searchString.trim() !== '') {
            const searchTerm = filter.searchString.toLowerCase().trim();
            console.log('[Approval Panel] Adding search filter:', searchTerm);
            query = query
              .where('name', '>=', searchTerm)
              .where('name', '<=', searchTerm + '\uf8ff');
          }

          // Add default ordering
          query = query.orderBy('createdAt', 'desc');

          console.log('[Approval Panel] Final query built:', query);
          return query;
        } catch (error) {
          console.error('[Approval Panel] Error building query:', error);
          // Return a basic query that just gets pending items
          return ref
            .where('status', '==', 'pending')
            .orderBy('createdAt', 'desc');
        }
      };

      const result = this.firebaseHelperService.getCollectionItems({
        collectionName,
        queryFn,
      });

      // Add logging for the observable
      result.subscribe(
        items => {
          console.log(
            `[Approval Panel] ${collectionName} items fetched:`,
            items?.length || 0
          );
          console.log(`[Approval Panel] ${collectionName} items:`, items);
        },
        error => {
          console.error(
            `[Approval Panel] Error fetching ${collectionName}:`,
            error
          );
        }
      );

      return result;
    }

    // Regular view handling (non-admin panel)
    if (!filter || filter === false) {
      filter = { status: 'approved' };
    }

    const queryFn = ref => {
      let query = ref;
      try {
        const myContent = filter?.myContent === true;

        // Add status filter first
        if (filter.status && !myContent) {
          query = query.where('status', '==', filter.status);
        }

        // Add other filters if they exist and are actively set
        if (filter?.country) {
          query = query.where('country.code', '==', filter.country);
        }

        if (filter?.freeEntry === true) {
          query = query.where('entryFree', '==', filter.freeEntry);
        }

        if (filter?.dogsAllowed === true) {
          query = query.where('dogsAllowed', '==', filter.dogsAllowed);
        }

        if (filter?.naturePools === true) {
          query = query.where('natural', '==', filter.naturePools);
        }

        if (filter?.finsAllowed === true) {
          query = query.where('finsAllowed', '==', filter.finsAllowed);
        }

        // Handle myContent filter
        if (myContent) {
          query = query.where('status', 'in', [
            'approved',
            'pending',
            'rejected',
          ]);
        }

        // Add default ordering
        query = query.orderBy('createdAt', 'desc');

        return query;
      } catch (error) {
        // Return a basic query with the status filter
        return ref
          .where('status', '==', filter.status || 'approved')
          .orderBy('createdAt', 'desc');
      }
    };

    return this.firebaseHelperService.getCollectionItems({
      collectionName,
      queryFn,
    });
  }

  getMyItems(collectionName, creator) {
    const queryFn = ref => {
      let query = ref;

      query = query.where('creator.id', '==', creator);

      return query;
    };

    return this.firebaseHelperService.getCollectionItems({
      collectionName,
      queryFn,
    });
  }

  userPoolsFilter(pools, userId) {
    return pools?.filter(item => {
      const creatorId = item?.creator?.id || item?.creator;
      return creatorId === userId;
    });
  }

  checkFilter(filter) {
    // If filter is false or undefined, show all items
    if (!filter || filter === false) {
      return true;
    }

    // Check if any filter is actively set
    const hasActiveFilter =
      (filter.country && filter.country.length > 0) ||
      filter.dogsAllowed === true ||
      filter.naturePools === true ||
      filter.finsAllowed === true ||
      filter.freeEntry === true ||
      filter.myContent === true;

    return hasActiveFilter;
  }
}

